import { IDoorAssessment, DoorAssessment } from '../../common/door-assessment';
import { IDiscountRequest, DiscountRequest } from './discount-request';

export interface IRecordAssessmentRequest {
    datePerformed: number;
    commuteTimeBlocks: number;
    installationAssessments: IDoorAssessment[];
    notes: string;
    projectRejected: boolean;
    assessmentCancelled: boolean;
    customerNotes: string;
    taxExemptionFormUrl: string;
    discounts: IDiscountRequest[];
}


export class RecordAssessmentRequest implements IRecordAssessmentRequest {
    public datePerformed: number = 0;
    public commuteTimeBlocks: number = 0;
    public installationAssessments: IDoorAssessment[] = [];
    public notes: string = '';
    public projectRejected: boolean = false;
    public assessmentCancelled: boolean = false;
    public customerNotes: string = '';
    public taxExemptionFormUrl: string = '';
    public discounts: IDiscountRequest[] = [];
}


